"use client";

import Link from "next/link";
import { useActionState } from "react";
import { loginAction, type AuthActionState } from "@/app/actions/auth";
import {
  btnPrimaryCls,
  errorTextCls,
  inputCls,
  labelCls,
  linkAccentCls,
} from "@/components/form-classes";

const initial: AuthActionState = null;

type Props = { defaultNext: string };

export function LoginForm({ defaultNext }: Props) {
  const [state, formAction, pending] = useActionState(loginAction, initial);

  return (
    <form action={formAction} className="mx-auto max-w-md space-y-5">
      <input type="hidden" name="next" value={defaultNext} />

      {state?.error ? (
        <p className={errorTextCls} role="alert">
          {state.error}
        </p>
      ) : null}

      <div>
        <label htmlFor="login-email" className={labelCls}>
          E-Mail
        </label>
        <input
          id="login-email"
          name="email"
          type="email"
          autoComplete="email"
          required
          className={inputCls}
        />
        {state?.fieldErrors?.email ? (
          <p className={`mt-1 ${errorTextCls}`}>{state.fieldErrors.email}</p>
        ) : null}
      </div>

      <div>
        <label htmlFor="login-password" className={labelCls}>
          Passwort
        </label>
        <input
          id="login-password"
          name="password"
          type="password"
          autoComplete="current-password"
          required
          className={inputCls}
        />
        {state?.fieldErrors?.password ? (
          <p className={`mt-1 ${errorTextCls}`}>{state.fieldErrors.password}</p>
        ) : null}
      </div>

      <button type="submit" disabled={pending} className={`${btnPrimaryCls} w-full`}>
        {pending ? "Wird angemeldet …" : "Anmelden"}
      </button>

      <p className="text-center text-sm text-zinc-400">
        Noch kein Konto?{" "}
        <Link href="/register" className={linkAccentCls}>
          Zur Registrierung
        </Link>
      </p>
    </form>
  );
}
